<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Documentos" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="card">
        <div class="card-body">
          <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <form class="forms-sample">
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="inputCategory" class="required">Categoria</label>
                        <input type="text" v-model="formulario.category" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputCategory" maxlength="50">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.category}}</div>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="inputTitle" class="required">Título</label>
                        <input type="text" v-model="formulario.title" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputTitle">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.title}}</div>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="textAreaSummary" class="required">Síntese</label>
                        <textarea class="form-control" rows="7" v-model="formulario.summary" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" id="textAreaSummary" ></textarea>
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.summary}}</div>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="inputArquivos">Arquivo</label>
                        <UploadFile
                          v-model="formulario.arquivos"
                          :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                          :accept="tiposDocumentoAceitos"
                        />
                        <div div class="avisoDanger text-left mt-1">{{retorno.listaDeErros['arquivos.*']}}</div>
                      </div>
                      <div v-if="formulario.id != null" class="form-group col-md-12">
                        <div class="row btn-group btn-group-justified" role="group">
                          <b-button class="botoes" variant="outline-primary btn-sm" @click="baixarDocumento(formulario.id, formulario.file_original_name)" :disabled="arquivoNaoLocalizado || flagsDeControle.carregandoDados.status">Download</b-button>
                          <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoArquivo.status"/>
                        </div>
                       </div>
                      <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                        <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                        <b-spinner class="ml-2" variant="danger"></b-spinner>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="card-footer text-right">
                  <div class="row btn-group btn-group-justified" role="group">
                    <div class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" @click="salvarRegistro()">Salvar</b-button></div>
                    <router-link class="" to="/administracao-documentos">
                      <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Cancelar</b-button>
                    </router-link>
                  </div>
                </div>
              </div> <!-- card ends -->
            </div>
          </div><!-- row ends -->
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</div>
<!-- ./wrapper -->
</template>

<script>
import Cadastro from './js/cadastro-documentos'
export default Cadastro
</script>

<style scoped>
@import "./scss/documentos.scss";
</style>
